import React, { useState } from 'react';
import { FileUp } from 'lucide-react';
import ResumeUploadModal from './ResumeUpload';

const UploadResumeContent = ({ jobId, onUpload }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isUploading, setIsUploading] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleUpload = async (files) => {
    try {
      setIsUploading(true);
      await onUpload(files);
      setIsModalOpen(false);
    } catch (error) {
      console.error('Error uploading resumes:', error);
      throw error;
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <>
      <div className="p-6 max-w-5xl mx-auto">
        {/* Header with Hello Message */}
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold mb-2">
            <span className="text-orange-500">Hello,</span> I'm HRgpt!
          </h1>
        </div>

        {/* Steps Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
          <div className="bg-gradient-to-r from-orange-500 to-yellow-500 p-6 rounded-xl text-white">
            <h2 className="text-lg font-semibold mb-2">01 Upload Resumes</h2>
            <p className="text-sm opacity-90">
              Upload up to 50 resumes at once in PDF or DOCX format
            </p>
          </div>

          <div className="bg-white p-6 rounded-xl border border-gray-200">
            <h2 className="text-lg font-semibold text-gray-800 mb-2">02 Process Candidates</h2>
            <p className="text-sm text-gray-600">
              HRgpt will analyze and score candidates based on AI, match, and ATS criteria
            </p>
          </div>
        </div>

        {/* Upload Card */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200">
          <div className="p-6">
            <div 
              onClick={handleOpenModal}
              className="border-2 border-dashed rounded-lg p-8 text-center cursor-pointer hover:border-orange-500 transition-colors"
            >
              <FileUp className="w-12 h-12 mx-auto mb-4 text-gray-400" />
              <h3 className="text-lg font-medium text-gray-900 mb-2">Upload Resumes</h3>
              <p className="text-sm text-gray-500">
                Click to upload or drag and drop your resumes here
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Upload Modal */}
      <ResumeUploadModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onUpload={handleUpload}
        jobId={jobId}
        onBankAttached={handleCloseModal}
      />
    </>
  );
};

export default UploadResumeContent;
